import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import AppRoutes from './routes/AppRoutes';
import PageViewTracker from './components/Analytics/PageViewTracker';

function App() {
  // useEffect(() => {
  //   // Additional security: Disable developer tools shortcuts
  //   const handleKeyDown = (e) => {
  //     // F12 - Developer Tools
  //     if (e.keyCode === 123) {
  //       e.preventDefault();
  //       e.stopPropagation();
  //       return false;
  //     }
      
  //     // Ctrl+Shift+I - Inspect Element
  //     if (e.ctrlKey && e.shiftKey && e.keyCode === 73) {
  //       e.preventDefault();
  //       e.stopPropagation();
  //       return false;
  //     }
      
  //     // Ctrl+Shift+J - Console
  //     if (e.ctrlKey && e.shiftKey && e.keyCode === 74) {
  //       e.preventDefault();
  //       e.stopPropagation();
  //       return false;
  //     }
      
  //     // Ctrl+Shift+C - Inspect Element (Chrome)
  //     if (e.ctrlKey && e.shiftKey && e.keyCode === 67) {
  //       e.preventDefault();
  //       e.stopPropagation();
  //       return false;
  //     }
      
  //     // Ctrl+U - View Source
  //     if (e.ctrlKey && e.keyCode === 85) {
  //       e.preventDefault();
  //       e.stopPropagation();
  //       return false;
  //     }
      
  //     // Ctrl+S - Save Page
  //     if (e.ctrlKey && e.keyCode === 83) {
  //       e.preventDefault();
  //       e.stopPropagation();
  //       return false;
  //     }
      
  //     // Ctrl+P - Print (optional, can disable if needed)
  //     if (e.ctrlKey && e.keyCode === 80) {
  //       e.preventDefault();
  //       e.stopPropagation();
  //       return false;
  //     }
  //   };
    
  //   // Disable right-click context menu
  //   const handleContextMenu = (e) => {
  //     e.preventDefault();
  //     e.stopPropagation();
  //     return false;
  //   };
    
  //   // Add event listeners
  //   document.addEventListener('keydown', handleKeyDown, true);
  //   document.addEventListener('contextmenu', handleContextMenu, true);
    
  //   // Cleanup
  //   return () => {
  //     document.removeEventListener('keydown', handleKeyDown, true);
  //     document.removeEventListener('contextmenu', handleContextMenu, true);
  //   };
  // }, []);
  
  return (
    <HelmetProvider>
      <BrowserRouter basename="">
        <PageViewTracker />
        <div className="h-screen flex flex-col bg-white dark:bg-gray-900 overflow-hidden transition-colors duration-200">
          {/* Header - Fixed, never scrolls */}
          <header className="flex-shrink-0">
            <Header />
          </header>
          
          {/* Scrollable wrapper - Contains Main + Footer */}
          <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
            {/* Main Content - Natural height */}
            <main className="min-h-full">
              <AppRoutes />
            </main>
            
            {/* Footer - Scrolls with content */}
            <footer className="flex-shrink-0">
              <Footer />
            </footer>
          </div>
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
